import {z} from 'zod';
import {
  briefSchema,
  conceptNodeSchema,
  strategyDecisionLogicSchema,
} from './copilotCampaigns.schemas';

enum AffectedAdObjects {
  Products = 'products',
  Store = 'store',
  SportEvent = 'sport_event',
  ContentItem = 'content_item',
  Creative = 'creative',
}

enum AiOutputType {
  Regular = 'Regular',
  Fallback = 'Fallback',
  Last = 'Last',
  PartialSuccess = 'PartialSuccess',
}

enum AiNodeType {
  VIDEO_CAMPAIGN = 'VIDEO_CAMPAIGN',
  CAMPAIGN = 'Campaign Card',
  CONDITION = 'Condition Card',
  COMPOUND_CONDITION = 'COMPOUND_CONDITION',
  WEIGHTED = 'Weighted Card',
  DISTRIBUTION = 'Distribution Card',
  PRODUCTS = 'Product Selection Card',
  STORE = 'Location Card',
  GENERAL_OPTIMIZATION = 'Optimization Card',
  SCHEDULE = 'Schedule Card',
  SEQUENCE = 'Sequence Card',
  CREATIVE = 'Creative Card',
  NATIVE_CREATIVE = 'NATIVE_CREATIVE',
  SOCIAL_FACEBOOK_AD_CREATIVE = 'SOCIAL_FACEBOOK_AD_CREATIVE',
  SOCIAL_TIKTOK_AD_CREATIVE = 'SOCIAL_TIKTOK_AD_CREATIVE',
  SOCIAL_YOUTUBE_AD_CREATIVE = 'SOCIAL_YOUTUBE_AD_CREATIVE',
  SOCIAL_SNAPCHAT_AD_CREATIVE = 'SOCIAL_SNAPCHAT_AD_CREATIVE',
  SOCIAL_YOUTUBE_DV360_AD_CREATIVE = 'SOCIAL_YOUTUBE_DV360_AD_CREATIVE',
  FACEBOOK_CAROUSEL_CREATIVE = 'FACEBOOK_CAROUSEL_CREATIVE',
  CONCEPT_CREATIVE = 'CONCEPT_CREATIVE',
  FACEBOOK_DPA_CREATIVE = 'FACEBOOK_DPA_CREATIVE',
  FACEBOOK_DPA_CAROUSEL_CREATIVE = 'FACEBOOK_DPA_CAROUSEL_CREATIVE',
}

type StrategyDecisionLogic = z.infer<typeof strategyDecisionLogicSchema>;
type ConceptNode = z.infer<typeof conceptNodeSchema>;
type AiCampaignMiniBrief = z.infer<typeof briefSchema>;

type ConceptPlanCopilotContextData = {conceptPlan: ConceptNode[]};

type CampaignLogicCopilotContextData = null;

type CampaignInsightsCopilotContextData = null;

export {
  AffectedAdObjects,
  AiCampaignMiniBrief,
  AiNodeType,
  AiOutputType,
  CampaignInsightsCopilotContextData,
  CampaignLogicCopilotContextData,
  ConceptNode,
  ConceptPlanCopilotContextData,
  StrategyDecisionLogic,
};
